import * as React from 'react';
import Link from '@mui/material/Link';
import LaunchIcon from '@mui/icons-material/Launch';


const runLink = "https://www.strava.com/routes/3337989852003352188";

type RunLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: RunLinkProps = {
  linkText: "Open Route Information in Strava",
  underline: "hover"
};

export default function RunLink(linkProps: RunLinkProps = defaultProps) {
  return (
          <Link href={runLink} 
            underline={linkProps.underline ? linkProps.underline : defaultProps.underline}
            >
            {linkProps.linkText ? linkProps.linkText : defaultProps.linkText}&nbsp;<LaunchIcon fontSize='inherit' />
          </Link>
  );
}